import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";

import { getClsSecListSvc, getRoleListSvc, saveStaffDtlsSvc } from './staffDtlsSvc';


function EditStaffSlider(props) {

  const { staffObj, closeSlider } = props;

  const [editLoader, setEditLoader] = useState("none");
  const [editOpacity, setEditOpacity] = useState(1);
  const [staffId, setStaffId] = useState(0);
  const [staff, setStaff] = useState("");
  const [roleId, setRoleId] = useState(0);
  const [sectionId, setSectionId] = useState(0);
  const [lstClsSec, setLstClsSec] = useState([]);
  const [lstRole, setLstRole] = useState([]);
  const [photoPath, setPhotoPath] = useState(window.appURL + "/no-image.png");
  const [photoFile, setPhotoFile] = useState(null);
  const imgBasePath = "https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=";


  useEffect(() => {
    // console.log("TopperForm called, staffObj", staffObj);
    getClsSecList();
    getRoleList();
    if (!!staffObj) {
      setStaffId(staffObj.staffId);
      setStaff(staffObj.staff);
      setRoleId(staffObj.roleId);
      setSectionId(staffObj.sectionId);
      setPhotoPath(imgBasePath + staffObj.imgPath || window.appURL + "/no-image.png");
    }
  }, [staffObj]);


  const getClsSecList = () => {
    // console.log("getClsSecList called");
    setEditLoader("block");
    setEditOpacity(0.5);
    getClsSecListSvc(getClassListResponse);
  }


  const getClassListResponse = (data) => {
    // console.log("getClassListResponse called, data", data);
    if (data.status === "Success") {
      setLstClsSec(data.lstClsSec);
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setEditLoader("none");
    setEditOpacity(1);
  }

  const getRoleList = () => {
    // console.log("getRoleList called");
    setEditLoader("block");
    setEditOpacity(0.5);
    getRoleListSvc(getRoleListResponse);
  }


  const getRoleListResponse = (data) => {
    // console.log("getRoleListResponse called, data", data);
    if (data.status === "Success") {
      setLstRole(data.lstRole);
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setEditLoader("none");
    setEditOpacity(1);
  }

  const handlePhotoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setPhotoFile(file); // Save the file in state
      setPhotoPath(URL.createObjectURL(file)); // Show a preview
    }
  };

  const handlePhotoClick = () => {
    // Trigger file input click
    document.getElementById("img_photoId").click();
  };

  const onError = () => {
    setPhotoPath(window.appURL + "/no-image.png");
  };


  const saveStaffDtls = () => {
    // console.log("saveStaffDtls called");
    const staffDtlsObj = {
      staffId,
      staff,
      roleId,
      sectionId
    }
    if (photoFile) {
      // console.log("Image file ready to upload:", photoFile);
      setEditLoader("block");
      setEditOpacity(0.5);
      saveStaffDtlsSvc(staffDtlsObj, photoFile, saveStaffDtlsResponse);
    } else if (photoPath) {
      // console.log("Using existing image from imgPath.");
      fetch(photoPath)
        .then(response => response.blob())
        .then(blob => {
          const file = new File([blob], photoPath.split('/').pop(), { type: blob.type });
          setEditLoader("block");
          setEditOpacity(0.5);
          saveStaffDtlsSvc(staffDtlsObj, file, saveStaffDtlsResponse); // Use the created file
        })
        .catch(error => {
          console.error("Error fetching the image:", error);
          toast.error("Failed to process the displayed image. Please upload a new one.");
        });
    } else {
      // console.log("No image file selected.");
    }
  }



  const saveStaffDtlsResponse = (data) => {
    // console.log("saveStaffDtlsResponse called, data", data);
    if (data.status === "Success") {
      toast.success(data.message);
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setEditLoader("none");
    setEditOpacity(1);
  }


  const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
      toast.error("You are not logged in. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
      toast.error("Server timed out. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      toast.error(svcMsg);
    }
  };


  return (

    <div>
      <button
        type="button"
        className="btn btn-info text-center btnCloseDiv"
        onClick={closeSlider}
        style={{ right: "60%" }}
      >
        <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
      </button>
      <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '58%', top: '45%', display: editLoader }}>
        <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
      </div>
      <div className="col-md-12 col-xs-12 col-centered padding-remove "
        style={{
          cursor: (editLoader === "none") ? 'pointer' : 'none',
          pointerEvents: (editLoader === "none") ? 'auto' : 'none',
          opacity: editOpacity
        }}>
        <div className="col-md-12 col-xs-12 col-centered" style={{ marginTop: "40px" }}>
          <div className="col-sm-12 col-xs-12 padding-remove">
            <div className="col-sm-12 col-md-12 padding-remove" style={{ width: "94%", margin: "3%", background: "#fff", border: "1px solid #ccc", borderRadius: 10 }}>
              <form id="editTopperForm" className="form form-horizontal" style={{ height: "80vh", overflowX: "hidden", padding: "20px 20px 5px 20px" }}>
                <div className="form-group col-md-12 padding-remove">
                  <label className="control-label col-md-3 col-xs-6" style={{ padding: "7px 10px 0 0" }}>
                    Name:
                  </label>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <input
                      type="text"
                      className="form-control"
                      value={staff}
                      onChange={(e) => setStaff(e.target.value)}
                      placeholder="Staff Name"
                    />
                  </div>
                </div>
                <div className="form-group col-md-12 padding-remove">
                  <label className="control-label col-md-3 col-xs-6" style={{ padding: "7px 10px 0 0" }}>
                    Role:
                  </label>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <select autoComplete="off" name="Role"
                      type="text" className="form-control "
                      value={roleId}
                      onChange={(e) => setRoleId(e.target.value)}
                    >
                      <option value="0" >Role</option>
                      {lstRole && lstRole.length ?
                        lstRole.map((obj) => (
                          <option key={obj.roleId} value={obj.roleId} >{obj.role}</option>
                        )) : null
                      }
                    </select>
                  </div>
                </div>
                <div className="form-group col-md-12 padding-remove">
                  <label className="control-label col-md-3 col-xs-6" style={{ padding: "7px 10px 0 0" }}>
                    Class:
                  </label>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <select autoComplete="off"
                      name="Class Section"
                      type="text" className="form-control "
                      value={sectionId}
                      onChange={(e) => setSectionId(e.target.value)}
                    >
                      <option value="0" >Class</option>
                      {lstClsSec && lstClsSec.length ?
                        lstClsSec.map((obj) => (
                          <option key={obj.sectionId} value={obj.sectionId} >{obj.classLabel + " - " + obj.section}</option>
                        )) : null
                      }
                    </select>
                  </div>
                </div>
                <div className="form-group col-md-12 padding-remove">
                  <label className="control-label col-md-3 col-xs-6" style={{ padding: "7px 10px 0 0" }}>
                    Photo:
                  </label>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <input
                      type="file"
                      id="img_photoId"
                      name="img"
                      onChange={handlePhotoChange}
                      className="hidden"
                      accept="image/*"
                    />
                    <img
                      src={photoPath}
                      alt="img"
                      onClick={handlePhotoClick}
                      height="160"
                      width="160"
                      style={{ width: 160, border: "1px solid #ddd" }}
                      onError={onError}
                    />
                  </div>
                </div>
                <div className="col-sm-10 padding-remove" style={{ height: "50px", marginTop: "30px" }}>
                  <div className="col-sm-6 col-md-6 padding-remove pull-right">
                    <div className="col-sm-6 col-md-6 padding-remove pull-right">
                      <button type="button" onClick={() => saveStaffDtls()} className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditStaffSlider;